import { DefaultButton, Icon, PrimaryButton, Stack, Tooltip } from "@fluentui/react";
import {
    CancelIcon,
    ChatIcon,
    CheckMarkIcon,
    ToggleThumbIcon,
    TriangleSolidUp12Icon,
} from "@fluentui/react-icons-mdl2";
import React, { useState, useRef, useEffect, useContext } from "react";
import { t } from "i18next";
import { CUSTOM_STYLES, PATHOLOGY_STATUS, TAB_NAME, TOAST_TYPE, USERTYPES } from "../../../constants/Constants";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import userContext from "../../../context/users/UserContext";
import loaderContext from "../../../context/loader/LoaderContext";
import { handleAcceptAcessRequest, handleRejectAcessRequest } from "../../../service/StudyListService";
import toastContext from "../../../context/toast/ToastContext";
import studylistContext from "../../../context/studylist/StudylistContext";
import Moment from "moment";
import { RowBadgeStatic } from "./RadiologistDetails";
import RowBadge from "./Badge/RowBadge";

const firstRowNameStack = {
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "center",
    lineHeight:'20px'
  };

const RequestDetails = (props) => {

    const { roles, username, userId, privilegedFirmDoctor } = useContext(userContext)
    const {ref, setLoaderRunning, setShowModal, showModal} = useContext(loaderContext);
    const {showToastv2} = useContext(toastContext);
    const { refreshRequired, setRefreshRequired, showAiResults, showSavedReport } = useContext(studylistContext);
    const data = props.data.row.original.archivedStudyAccessRequestDto;
    const formatDate = (timestamp) => {
        var currentDate = Moment(timestamp).local().format("DD-MMM-YY hh:mm A");
        return currentDate;
    };

   

    const roleAbbreviations = {
        [USERTYPES.RADIOLOGIST]: "R",
        [USERTYPES.FIRMTECHNICIAN]: "T",
        [USERTYPES.FIRMDOCTOR]: "D",
        [USERTYPES.FIRMADMIN]: "FA",
        [USERTYPES.SUPERVISOR]: "S",
        [USERTYPES.TYPIST]: "T"
    };

    const roleDisplay = roleAbbreviations[data.requestorRole] || " ";

    const mainStackStyles = {
        justifyContent: "center",
        marginTop: CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
        marginLeft: "10px"
    };

    const customDescriptionStyles = {
        root: "studylist-request-details"
    }

    const customToolTipStyleForIcons = {
        root: "study-list-report-image-count-container",
    }

    const studyDetailsIconsContainer = {
        display: "flex",
        justifyContent: "flex-start",
        flex: "1",
        position: "relative",
        cursor: "pointer",
        // width: "64%",
        height: "24px !important",
        marginTop: "24px",
        marginBottom: "5px",
    };

    const msgIconToolTipStyles = {
        root: {
            height: "24px",
            display: "flex",
            alignItems: "center",
            marginRight: "15px"
        },
    };

    const handleAcceptRequest = async () => {
        ref.current.continuousStart();
        const details = await handleAcceptAcessRequest(props.data.row.original.id, userId, data.requestId);
        console.log("--- Response Accept Request ----",details);
        if (details.data.result === "SUCCESS") {
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, "Successfully accepted study access request!")
            setRefreshRequired(()=>{
                                  const newItem = {...refreshRequired};
                                  newItem[TAB_NAME.PENDING].alreadyLoaded = false;
                                  return newItem;
                                });
        }
        else {
            ref.current.complete();
            showToastv2(TOAST_TYPE.ERROR, details.data.message ? details.data.message : "Some error occured!")
        }
        
    }

    const handleRejectRequest = async () => {
        ref.current.continuousStart();
        const details = await handleRejectAcessRequest(props.data.row.original.id, userId, data.requestId);
        console.log("--- Response Reject Request ----",details);
        if (details.data.result === "SUCCESS") {
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, "Successfully rejected study access request!")
            setRefreshRequired(()=>{
                const newItem = {...refreshRequired};
                newItem[TAB_NAME.PENDING].alreadyLoaded = false;
                return newItem;
              });
        }
        else {
            ref.current.complete();
            showToastv2(TOAST_TYPE.ERROR, details.data.message ? details.data.message : "Some error occured!")
        }
    }


    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: 'center'
                }}
            >
                <Stack data-tut={"tour-study-details"} style={mainStackStyles}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Stack horizontal style={firstRowNameStack}>
                            <span className="study-list-assignment-details-text">
                                <RowBadgeStatic
                                    name={roleDisplay}
                                    tooltipText={data.requestorRole}
                                />
                            </span>

                            <CustomToolTipHost
                                content={`Request - ${data.requestorName} : ${formatDate(data.requestedDate)}`}
                                styles={customDescriptionStyles}
                                id={"tooltip_"}
                            >
                                <span
                                    className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                                    style={{ display: 'block' }}
                                >&nbsp;&nbsp;{data.requestorName}</span>
                            </CustomToolTipHost>

                        </Stack>
                    </div>

                    {/* <span className="study-list-study-date">
                        <CustomToolTipHost
                            content={formatDate(data.requestedDate)} styles={customDescriptionStyles} id={"tooltip_"}>
                            {"Requested"}:&nbsp;&nbsp;
                            <span className="study-list-date">{formatDate(data.requestedDate) || "-"}</span>
                        </CustomToolTipHost>
                    </span> */}

                    {data.reason &&
                        <span className="study-list-study-date">
                            <CustomToolTipHost styles={customDescriptionStyles}
                                content={data.reason} id={"tooltip_"}>
                                {"Reason"}:&nbsp;&nbsp;
                                {data.reason}
                            </CustomToolTipHost>
                        </span>}

                    {props.tabId === "pending" && (
                        <div style={studyDetailsIconsContainer}>
                            <CustomToolTipHost
                                content={"Accept Request"}
                                id={"tooltip_"}
                                styles={msgIconToolTipStyles}>
                                {/* <div style={{ display: 'flex', alignItems: 'center' }}
                                    onClick={() => handleAcceptRequest()} >
                                    <CheckMarkIcon style={{ color: "green" }} />
                                </div> */}
                                <PrimaryButton
                                            iconProps={{
                                              iconName: "CheckMark",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>  handleAcceptRequest() }
                                            text={""}
                                            className={"common-default-active-button search-active-button"}
                                            styles={{root:{
                                                    width: "10px",
                                                    cursor: "pointer",
                                                    background: "#0eb069",
                                                    border: "1px solid #0eb069"
                                                  },
                                                  rootHovered: {
                                                    background: "#0eb069",
                                                    border: "1px solid #0eb069",
                                                  },
                                                  rootPressed: {
                                                    background: "#0eb069",
                                                    border: "1px solid #0eb069",
                                                  }}
                                            }
                                          />
                                 
                            </CustomToolTipHost>


                            
                            {/* <div style={{display:'flex',alignItems:'center',marginLeft:'7px'}}>
          <RowBadge
          customClassName = "study-list-modality-badge"
          tooltipText={"Accept Request"}
            name={"accept"}
            colorObj={{ background: '#E37475', color: '#FFFFFF' }}
          />
          </div> */}

                            <CustomToolTipHost
                                content={"Reject Request"}
                                id={"tooltip_"}
                                styles={msgIconToolTipStyles}>
                                {/* <div style={{ display: 'flex', alignItems: 'center' }}
                                    onClick={() => handleRejectRequest()}>
                                    <CancelIcon style={{ color: "red" }} />
                                </div> */}
                                <PrimaryButton
                                            iconProps={{
                                              iconName: "Cancel",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>  handleRejectRequest() }
                                            text={""}
                                            className={"common-default-active-button search-active-button"}
                                            styles={{root:{
                                                    width: "10px",
                                                    cursor: "pointer",
                                                    background: "#ff0000",
                                                    border: "1px solid #ff0000"
                                                  },
                                                  rootHovered: {
                                                    background: "#ff0000",
                                                    border: "1px solid #ff0000",
                                                  },
                                                  rootPressed: {
                                                    background: "#ff0000",
                                                    border: "1px solid #ff0000",
                                                  }}
                                            }
                                          />
                                
                            </CustomToolTipHost>
                        </div>)}
                    {props.tabId == "approved" && <>
                        <span className="study-list-study-date">
                            <CustomToolTipHost styles={customDescriptionStyles}
                                content={`Aprroval - ${data.approverName} : ${formatDate(data.approvedDate)}`} id={"tooltip_"}>
                                {"Approved By"}:&nbsp;&nbsp;
                                {data.approverName}
                            </CustomToolTipHost>
                        </span>
                        {/* <span className="study-list-study-date">
                            <CustomToolTipHost
                                content={formatDate(data.approvedDate)} styles={customDescriptionStyles} id={"tooltip_"}>
                                {"Approved On"}:&nbsp;&nbsp;
                                <span className="study-list-date">{formatDate(data.approvedDate) || "-"}</span>
                            </CustomToolTipHost>
                        </span> */}
                    </>}

                    {props.tabId == "rejected" && <>

                        <span className="study-list-study-date">
                            <CustomToolTipHost
                                content={data.status} styles={customDescriptionStyles} id={"tooltip_"}>
                                {"Status"}:&nbsp;&nbsp;
                                <span className="study-list-date">{data.status || "-"}</span>
                            </CustomToolTipHost>
                        </span>

                        {data.status == "REJECTED" &&

                            <span className="study-list-study-date">
                                <CustomToolTipHost styles={customDescriptionStyles}
                                    content={`Rejection - ${data.rejectorName} : ${formatDate(data.rejectedDate)}`} id={"tooltip_"}>
                                    {"Rejected By"}:&nbsp;&nbsp;
                                    {data.rejectorName}
                                </CustomToolTipHost>
                            </span>
                        }

                        {/* <span className="study-list-study-date">
                            <CustomToolTipHost
                                content={formatDate(data.rejectedDate)} styles={customDescriptionStyles} id={"tooltip_"}>
                                {"Rejected On"}:&nbsp;&nbsp;
                                <span className="study-list-date">{formatDate(data.rejectedDate) || "-"}</span>
                            </CustomToolTipHost>
                        </span> */}
                    </>}
                </Stack>


            </div>
        </>
    );
};

export default RequestDetails;

